var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(-1413 -2740)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M43,48H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H43a5.006,5.006,0,0,1,5,5V43A5.006,5.006,0,0,1,43,48ZM18,5.3a7,7,0,0,0-3.833,12.848,6.992,6.992,0,0,0,0,11.7A7,7,0,0,0,18.035,42.7a7.1,7.1,0,0,0,7.111-7.072V31l0-1.82A6.975,6.975,0,0,0,29.85,31H30a7,7,0,0,0,3.833-12.847A7,7,0,0,0,30,5.3H18Zm.039,35.1A4.7,4.7,0,1,1,18,31h4.858v4.628A4.806,4.806,0,0,1,18.037,40.406ZM30,28.7h-.152a4.7,4.7,0,0,1,0-9.41H30a4.7,4.7,0,0,1,0,9.41Zm-7.149,0H18a4.7,4.7,0,0,1,0-9.41h4.857v4.547c0,.052,0,.105,0,.158s0,.106,0,.158V28.7ZM30,17H25.148V7.594H30A4.7,4.7,0,0,1,30,17Zm-7.15,0H18a4.705,4.705,0,0,1,0-9.41h4.855V17Z",
    transform: "translate(1413 2740)",
    fill: "#ffb400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.a17f5c61572f75d4084cf594cca25a4b.svg";
export { ForwardRef as ReactComponent };